import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import _ from "lodash";
import {
    Chip,
    CircularProgress,
} from "@material-ui/core";
import useAdminUserSession from "../../../../hooks/useAdminUserSession";
import axios from "axios";
import {Autocomplete} from "@material-ui/lab";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    field: {
        '& label.Mui-focused': {
            color: '#000',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#000',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#000',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#000',
            },
        },
    },
    tabActive: {
        color: '#1E69E5',
    },
    associationLink: {
        position: 'absolute',
        top: '-10px',
        right: '10px',
        cursor: 'pointer',
        decoration: 'none',
        '&:hover': {
            decoration: 'none',
        }
    },
    inputWithAssociationLink: {
        position: 'relative',
    },
    urlContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
}));

const DesignationField = ({selectedValues, handleOnChange, ...props}) => {
    const classes = useStyles();
    const {session} = useAdminUserSession();
    const [selected, setSelected] = useState([]);
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;

    useEffect(() => {
        setSelected(selectedValues);
    }, [selectedValues]);

    const onChange = (event, value) => {
        handleOnChange(event, value);
    }

    const handleOpen = (event, open) => {
        if (open === true) {
            axios.get(
                `/v1/admin/achievements/filter`,
                {
                    params: { ids: selected.map(({id}) => id) },
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-Admin-User-Email': session.email,
                        'X-Admin-User-Token': session.token
                    }
                }
            ).then((response) => {
                const { status, achievements } = response.data;

                if (status === 'ok') {
                    if (open === true) {
                        setOptions(achievements);
                    }
                    setOpen(open);
                }
            });
        } else {
            setOpen(false);
        }
    }

    const handleInputChangeAutocomplete = (event, itemType) => {
        event.persist();
        debounceFilterInput(event, itemType);
    }

    const debounceFilterInput = _.debounce((event) => {
        axios.get(
            `/v1/admin/achievements/filter`,
            {
                params: { filter: event.target.value },
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': session.email,
                    'X-Admin-User-Token': session.token
                }
            }
        ).then((response) => {
            const { status, achievements } = response.data;

            if (status === 'ok') {
                setOptions(achievements);
            }
        });
    }, 650)

    return (
        <Autocomplete
            multiple
            id="achievement_ids"
            open={open}
            onOpen={(event) => handleOpen(event, true)}
            onClose={(event) => handleOpen(event, false)}
            onChange={(event, value) => onChange(event, value)}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            options={options}
            value={selected}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip label={option.name} {...getTagProps({ index })} />
                ))
            }
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Designations"
                    variant="outlined"
                    onChange={(event) => handleInputChangeAutocomplete(event)}
                    className={classes.field}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            {...props}
        />
    );
}

export default DesignationField;